<div class="modal right" id="stationModal" tabindex="-1" role="dialog" aria-labelledby="stationModalLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
					<h4 id="stationModalLabel" ng-if="!station.id">New Station</h4>
                    <h4 id="stationModalLabel" ng-if="station.id">Edit Station</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-7">
									<form ng-submit="postForm(station)" class="form-horizontal allcp-form">

										<div class="form-group floating">
											<input type="text" autocomplete="disabled" ng-model="station.code" class="form-control input-md" placeholder="Station Code" required>
											<label>Station Code</label>
										</div>

										<div class="form-group floating">
											<select
												ng-model="station.state"
												class="form-control input-md">
												<option value="">Select State</option>
												<option value="{{ state.name }}" ng-repeat="state in states track by $index">{{ state.name }}</option>
											</select>
											<label>Station State</label>
										</div>

										<div class="form-group floating">
											<input type="text" ng-model="station.city" class="form-control input-md" placeholder="Station City" required>
											<label>Station City</label>
										</div>

										<div class="form-group floating">
											<input google-place
												type="text"
												class="form-control input-md"
												placeholder="Station Address"
												ng-model="station.address"
												ng-change="getAddress(station.address)"
												id="googlePlaceInput"
												required>
											<label>Address</label>
										</div>

										<div class="form-group floating">
											<input type="text" ng-model="station.zipcode" class="form-control input-md" placeholder="Zipcode" required>
											<label>Zipcode</label>
										</div>

										<div class="form-group floating">
											<ui-select
													multiple
													tagging
													tagging-tokens=",|SPACE|ENTER"
													tagging-label="add zipcode"
													ng-model="station.zipcodes"
													theme="bootstrap"
													sortable="true"
													class="form-control input-md"
													style="width: 100%;height: 300px; overflow: auto;"
													title="Enter Zipcode">
												<ui-select-match placeholder="Enter Zipcodes...">{{$item}}</ui-select-match>
												<ui-select-choices repeat="tag in ctrl.availableColors | filter:$select.search">
													{{tag}}
												</ui-select-choices>
											</ui-select>
											<label>Zipcodes * :
												<a href="#"
												   class="hint--medium hint--top"
												   aria-label="Enter zipcode connected to this station">
													<i class="fa fa-question"></i>
												</a>
											</label>
										</div>

										<!-- <div class="form-group row">
											<label class="col-md-3 control-label">
												Station Label *
											</label>
											<div class="col-md-9">
												<label for="label" class="field">
													<input type="text" ng-model="station.label" class="gui-input br-light light" placeholder="Station Label" required>
												</label>
											</div>
										</div> -->
					
										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue" ng-disabled="loading">
													<span ng-if="!station.id">CREATE</span>
                    								<span ng-if="station.id">UPDATE</span>
												</a>
											</div>
										</div>
									</form>
								</div>
								<div class="col-md-5">
									<div id="mapStation" style="height:400px;"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
